import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { CustomVideoPlayer } from '../ui/CustomVideoPlayer';
const pills = ['📚 12 capítulos', '📄 +140 páginas', '🇦🇷 Sistema argentino', '📲 PDF digital'];
export function Hero() {
  return <header className="w-full bg-gradient-to-b from-ink-950 via-ink-900 to-pitch" data-id="element-109" data-mp="cu9u4mkjt8th">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-20 pt-4 text-center md:pb-28" style={{
      alignItems: "center",
      justifyContent: "flex-start"
    }} data-id="element-110" data-mp="hvqrw97qkf5u">
        <span className="inline-block rounded-full bg-brand-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold ring-1 ring-brand-gold/30" data-id="element-111" data-mp="quuehn643cp3">
          ⚽ Método Fútbol Digital
        </span>
        <h1 className="mt-8 font-display text-4xl font-black leading-[1.08] text-white sm:text-5xl md:text-6xl" data-id="element-112" data-mp="10k46l30ygvd7">
          Protegé, acompañá y <span className="text-brand-gold" data-id="element-113" data-mp="15ip6108dvb0l">potenciá la carrera</span>{' '}
          futbolística de tu hijo
        </h1>
        
        <div className="mt-10 mb-2 w-full max-w-[260px]" data-id="element-114" data-mp="9oc7qlvpvrho">
          <CustomVideoPlayer videoId="5q51xKeO6uY" data-id="element-115" data-mp="9lq0yognhg0i" />
        </div>
        <p className="mt-10 max-w-2xl text-base leading-relaxed text-body md:text-lg" style={{
        fontSize: "20px"
      }} data-id="element-116" data-mp="4ny9twntxxxd">
          <strong className="block font-bold text-white text-center" style={{
          fontSize: "20px"
        }} data-id="element-117" data-mp="3vx3ph3p69pa7">MÉTODO PARA PADRES DE FUTBOLISTAS</strong>
          El método listo para aplicar para padres y madres que quieren acompañar el desarrollo futbolístico de sus hijos, tomar mejores decisiones y evitar errores en el camino.
        </p>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-118" data-mp="inpj5k3eiq51">
          {pills.map(pill => <li key={pill} className="rounded-full border border-ink-border bg-ink-card/70 px-4 py-2 text-sm font-semibold text-body" data-id="element-119" data-mp="enp540k7sgyi">
              {pill}
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-120" data-mp="16ebmwz6dho98">
          <CtaButton size="xl" data-id="element-121" data-mp="16da2i43gvpeu">Obtener el método ahora</CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-122" data-mp="30lnm2hyexvow">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
      </div>
    </header>;
}